import { select } from '@ngneat/elf';

import { getHistoriesDataSource } from './history.requests';
import { historiesStore } from './history.store';

export class HistoriesQuery {
  store = historiesStore;

  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  histories$ = getHistoriesDataSource.data$();
  history$ = this.store.pipe(select((state) => state.history));

  get totalRows() {
    return this.store.getValue().pagination.total;
  }
}

export const historiesQuery = new HistoriesQuery();
